/** @module csi/widget/MenuLabel */
define([
	"dojo/_base/declare",
	"dojo/dom",
	"dijit/MenuSeparator",
	"dojo/text!./MenuLabel.html"
], function(declare,dom,MenuSeparator,template){

	return declare(MenuSeparator, {
		baseClass: "dijitMenuLabel",
		templateString: template,
		label: "",
		
		_setLabelAttr: {node: "containerNode", type: "innerText"}
	});
});
